import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { initI18n } from './shared/i18n/config';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { env } from '@/shared/config/env';
import '@/shared/theme/globals.scss';

// Initialize Sentry error tracking
if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    release: env.VITE_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: env.VITE_SENTRY_ENVIRONMENT === 'production' ? 0.1 : 1.0,
  });
}

// Initialize PostHog analytics
if (env.VITE_POSTHOG_KEY) {
  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST,
    capture_pageview: false,
    // Cookies on .events.com count against the ingress header size limit;
    // localStorage keeps PostHog state out of every API request.
    persistence: 'localStorage',
  });
}

// Initialize i18n before rendering so translations are available on
// the first render pass (avoids a flash of untranslated keys).
initI18n().then(() => {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element #root not found in document');
  }

  createRoot(rootElement).render(<App />);
});
